<template>
    <div class="templete no_print">
            <!-- <div class="path_title clearfix">
                <span class="path_title_name">立方小数点开启关闭设置</span>
                <div class="contractLabel" style="position:relative;">
                    <span class="redQuestion"></span>
                    <div class="labelTip">
                        <div class="labelZhu">注:</div>
                        <div class="laCbelTipC">开启后所有方数的小数点第四位为0时将自动隐藏，例如导入数据3.6780=3.678</div>
                    </div>
                </div>
            </div>
            <div>
                <span>开启后，去掉小数点多余的零 (码单立方、检尺立方、销售立方)</span>
            </div>
            <div class="path_switch">
                <el-radio-group v-model="radio" @change="timeChange">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </div> -->

            <div class="path_title clearfix">
                <span class="path_title_name">修改百分比与组装拆卸保留小数点设置</span>
                <div class="contractLabel" style="position:relative;">
                    <span class="redQuestion"></span>
                    <div class="labelTip">
                        <div class="labelZhu">注:</div>
                        <div class="laCbelTipC">
                            <span>1. 使用北美材、榉木码单模板导入的立方数，四舍五入保留设置的小数位数；</span><br/>
                            <span>2. 库存管理批量修改销售立方百分比计算结果四舍五入保留设置的小数位数；</span><br/>
                            <span>3. 销售单修改销售立方百分比计算结果四舍五入保留设置的小数位数；</span><br/>
                            <span>4. 组装拆卸拆包北美材、榉木模板导入的数据，修改码单立方或销售立方时，同步计算销售立方与检尺立方或码单立方与检尺立方的原方数占比，计算结果的立方数四舍五入保留设置的小数位数。</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="path_switch">
                <el-slider class="decimalSlider" v-model="decimalNum" @change="decimalChange" :step="1" :mix="0" :max="4" show-stops input-size="size" :marks="decimalMarks"></el-slider>
            </div>
            <div>
                <span class="decimalMarks">注：请拖动选择保留几位小数</span>
            </div>
         </div>
</template>
<style scoped lang="scss">
    .templete{overflow: auto;}
    .contractLabel{float: left;position: relative;top:3px;margin-left:10px;}
    .path_title_name{float: left;}
    .redQuestion{display: block;width:15px;height:15px;background: url('/icon/question.png') no-repeat 100%;background-size: 100% 100%;}
    .labelTip{display: none;position: absolute;top:20px;left:15px;z-index:100000;width:250px;text-align: left;background-color: #fff;border-radius: 4px;padding:10px;box-sizing: border-box;box-shadow: 1px 1px 5px #ccc;padding-left:30px;}
    .laCbelTipC{color:#606266;font-size: 12px;}
    .labelZhu{font-size: 12px;color:#b21111;position: absolute;top:10px;left:10px;}
    .contractLabel:hover{cursor: pointer;}
    .contractLabel:hover .labelTip{display: block;}
    .path_title{text-align: left;
        font-size:16px; font-weight:bold; margin-top: 26px;margin-bottom:20px;
        & + div{ margin-bottom: 20px; color: #333333; display: flex; align-items: center; }
    }
    .input_box{ width:80px; margin: 0 10px; }
    .container{
        padding: 34px 30px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
    }
    .path_switch{text-align: left;margin-bottom:20px;}
    .path{
            margin-bottom: 7px; display: flex; align-items: center; justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #b21111; padding-left: 12px;
            }
        }
    .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 100%; padding: 8px 10px;  }
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
    .gradeSection{width:700px;flex: 1;display: flex;flex-direction: column;}
    .starTableList .gradeStar{position: relative;top:5px;float: left;}
    .gradeStar{margin-right: 10px;margin-bottom:10px;}

    .decimalMarks{display: block;color: #777;text-align:left;margin-top: 10px;font-size: 13px;}
    .decimalSlider{width: 270px;display:block;}
    .decimalSlider /deep/ .el-slider__marks .el-slider__marks-text{width: 50px;font-size: 12px;}
    .decimalSlider /deep/ .el-slider__bar{background-color:#b21111;}
    .decimalSlider /deep/ .el-slider__button{border-color: #b21111;}
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                radio : 0,
                orderTime:"",

                decimalNum:Number(localStorage.getItem('dm_erp_decimal_scale')),
                decimalMarks:{
                    0:'0',
                    1:'0.1',
                    2:'0.01',
                    3:'0.001',
                    4:'0.0001',
                }
            }
        },
        created(){
            
        },
        mounted(){
            this.decimalGet()
        },
        methods:{
            decimalGet(){
                this.postFunc("/erp/system.get.config",{key:"DECIMAL_CUBE_SCALE"},res=>{
                    this.decimalNum = res.data.data.value==''?4:Number(res.data.data.value);
                    // 设置缓存
                    localStorage.setItem('dm_erp_decimal_scale',this.decimalNum);
                },error=>{
                    
                })
            },

            timeChange(){
                this.postFunc("/erp/system.set.config",{key:"ASSEMBLY_CUBE_SUB",status:this.radio,value:this.orderTime},()=>{
                    this.tip("操作成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            decimalChange(){
                let {decimalNum} = this.$data;
                this.postFunc("/erp/system.set.config",{key:"DECIMAL_CUBE_SCALE",value:decimalNum,status:1},res=>{
                    this.tip('设置成功',"success")
                    // 设置缓存
                    localStorage.setItem('dm_erp_decimal_scale',decimalNum);
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
        }
    }
</script>
